import _createForOfIteratorHelper from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import $ from "cash-dom";
import debounce from "lodash.debounce";
import queryString from "query-string";
import { findKey } from "lodash";
import initCharts from "./charts";
import initTables from "./tables";
var state = {};
var refreshCharts = debounce(initCharts, 1000);
export var stateToFips = {
  wyoming: "56",
  wisconsin: "55",
  "west virginia": "54",
  washington: "53",
  virginia: "51",
  vermont: "50",
  utah: "49",
  texas: "48",
  tennessee: "47",
  "south dakota": "46",
  "south carolina": "45",
  "rhode island": "44",
  pennsylvania: "42",
  oregon: "41",
  oklahoma: "40",
  ohio: "39",
  "north dakota": "38",
  "north carolina": "37",
  "new york": "36",
  "new mexico": "35",
  "new jersey": "34",
  "new hampshire": "33",
  nevada: "32",
  nebraska: "31",
  montana: "30",
  missouri: "29",
  mississippi: "28",
  minnesota: "27",
  michigan: "26",
  massachusetts: "25",
  maryland: "24",
  maine: "23",
  louisiana: "22",
  kentucky: "21",
  kansas: "20",
  iowa: "19",
  indiana: "18",
  illinois: "17",
  idaho: "16",
  hawaii: "15",
  georgia: "13",
  florida: "12",
  "district of columbia": "11",
  delaware: "10",
  connecticut: "09",
  colorado: "08",
  california: "06",
  arkansas: "05",
  arizona: "04",
  alaska: "02",
  alabama: "01",
  usa: "00"
};

function updateDownloadButton(state) {
  var downloadButton = $(".metric__download-button");
  var downloadHrefRoot = downloadButton.attr("data-href");
  var downloadFileRoot = downloadButton.attr("data-download");

  var adjustedState = _objectSpread({}, state);

  if (adjustedState.state) {
    adjustedState.state = adjustedState.state.filter(function (item) {
      return item !== "00";
    });
  }

  adjustedState.fips = adjustedState.state;
  delete adjustedState.state;
  downloadButton.attr("href", "".concat(downloadHrefRoot, "?").concat(queryString.stringify(adjustedState)));

  if (adjustedState.adjustment) {
    downloadButton.attr("download", "".concat(downloadFileRoot, " (").concat(adjustedState.adjustment, ").csv"));
  } else {
    downloadButton.attr("download", "".concat(downloadFileRoot, ".csv"));
  }
}

export function initAdjustments(metric) {
  var picker = $("#metric__adjustments-picker");
  var availableAdjustments = metric.adjustment_options;
  var query = queryString.parse(location.search);

  if ($("#metric__adjustments-picker .metric__adjustments").children().length > 0) {
    // Already exists, pass.
    return;
  }

  if (availableAdjustments.length > 0) {
    $(picker).removeAttr("hidden");
  }

  var _iterator = _createForOfIteratorHelper(availableAdjustments),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _adjustment = _step.value;
      var adjustmentString = _adjustment.adjustment;

      if (adjustmentString === "null") {
        adjustmentString = "";
      }

      $(picker).find(".metric__adjustments").append("\n      <label class=\"w-1/2 md:w-full block flex items-center mb-2 text-usafacts-gray text-sm\">\n        <input class=\"form-checkbox flex-shrink-0 text-usafacts-blue text-xl mr-2 border-2 border-gray-400\" type=\"radio\" name=\"adjustment\" tabindex=\"0\" data-adjustment=\"".concat(adjustmentString, "\">\n        <span>").concat(_adjustment.name, "</span>\n      </label>\n    "));
    } // Preselect elements that are part of the query.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (query) {
    state.adjustment = query.adjustment;
    state.state = query.state;
    var adjustment = state.adjustment;

    if (adjustment === "null") {
      adjustment = "";
    }

    $("#metric__adjustments-picker [data-adjustment='".concat(adjustment, "']")).prop("checked", true);
    updateDownloadButton(state);
  }

  $(picker).find("input").on("click", function (event) {
    var element = $(event.target);
    var adjustment = $(event.target).attr("data-adjustment");
    $(".data-metric-chart .dh-chart-wrapper .chart-loading").css("display", "flex");
    $(".data-metric-chart .dh-chart-wrapper .chart-loading").css("background", "rgba(255,255,255,.75)");

    if (state.adjustment === adjustment) {
      delete state.adjustment;
      $(event.target).prop("checked", false);
    } else {
      state.adjustment = adjustment;
    }

    history.pushState(null, "", "?".concat(queryString.stringify(state)));
    updateDownloadButton(state);
    refreshCharts(state.adjustment, state.state);
  });
}
export function initSotuSources(container, sources, meta) {
  var sourcesContainer = $(container).parent().parent().find(".metric__meta-modal");
  var toggleContainer = $(container).parent().parent().find(".sotu__sources-toggle");

  if (!sources.length && !meta.length) {
    $(toggleContainer).hide();
    return;
  }

  if (sources) {
    var sourceHtml = sources.map(function (source) {
      return "\n        <div class=\"flex justify-between mt-2 md:mt-4\">\n          <div>\n            <div class=\"text-xs sm:text-base font-bold text-gray-800\"><a href=\"".concat(source.url, "\" target=\"_blank\">").concat(source.agencyname, "</a></div>\n            ").concat(source.name ? "<div class=\"text-2xs sm:text-sm text-gray-600\"><a href=\"".concat(source.url, "\" target=\"_blank\">").concat(source.name, "</a></div>") : "", "\n          </div>\n          ").concat(source.lastupdated ? "<div class=\"w-auto text-right flex-shrink-0 ml-4\">\n            <div class=\"text-xs sm:text-base font-bold text-gray-800\">Last updated</div>\n            <div class=\"text-2xs sm:text-sm text-gray-600\">".concat(source.lastupdated, "</div>\n          </div>") : "", "\n        </div>\n      ");
    });
    $(sourcesContainer).append("".concat(sourceHtml.join("")));
  }

  if (meta) {
    var parsedMeta = {};

    var _iterator2 = _createForOfIteratorHelper(meta),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        parsedMeta[item.type] = [];
        parsedMeta[item.type].push(item.data);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    for (var prop in parsedMeta) {
      var propHtml = "\n      <div class=\"text-xs font-bold mt-3 mb-3 text-gray-900\">".concat(prop, "</div>\n      ");
      var formattedMeta = parsedMeta[prop].map(function (item) {
        return "<div class=\"text-xs mb-3 italic text-gray-800\">".concat(item, "</div>");
      });

      if (parsedMeta[prop].length > 0) {
        $(sourcesContainer).append("".concat(propHtml).concat(formattedMeta.join("")));
      }
    }
  }

  $(toggleContainer).on("click", function () {
    // Close all other open modals
    $(".metric__meta-modal").not(sourcesContainer).removeClass("active"); // Open modal associated with toggle clicked

    $(sourcesContainer).toggleClass("active");
  });
  $(toggleContainer).on("keypress", function (e) {
    if (e.which === 13) {
      $(sourcesContainer).toggleClass("active");
    }
  }); // Close modal with escape key

  document.addEventListener("keydown", function (e) {
    if (e.code === "Escape") {
      if (sourcesContainer) {
        $(sourcesContainer).removeClass("active");
      }
    }
  });
}
export function getFipsCodeByState(state) {
  return stateToFips[state.toLowerCase()];
}
export function initStatePicker(metric) {
  var picker = $("#metric__state-picker");
  var adjustments = null;
  var stateElements = $(picker).find("path");
  var queryState = queryString.parse(location.search).state;
  var toggleContainer = $(picker).find(".metric__state");
  var toggleHeading = $(picker).find(".metric__box-header");
  $(toggleHeading).on("click", function () {
    $(this).parent().toggleClass("active");
  }); // Preselect elements that are part of the query.

  if (queryState) {
    state.state = [].concat(queryState);

    var _iterator3 = _createForOfIteratorHelper(state.state),
        _step3;

    try {
      var _loop = function _loop() {
        var item = _step3.value;
        var key = findKey(stateToFips, function (st) {
          return st === item;
        });
        $("[data-state='".concat(key, "']")).addClass("active");
      };

      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  $(stateElements).on("click", function (event) {
    var chosenState = $(this).attr("data-state");
    var stateCode = getFipsCodeByState(chosenState.split("-").join(" "));
    $("#metric__state-picker [data-state='".concat(chosenState, "']")).toggleClass("active");
    $(".data-metric-chart .dh-chart-wrapper .chart-loading").css("display", "flex");
    $(".data-metric-chart .dh-chart-wrapper .chart-loading").css("background", "rgba(255,255,255,.75)");
    state.state = [].concat(state.state);

    if (state.state) {
      var index = state.state.indexOf(stateCode);

      if (index > -1) {
        state.state.splice(index, 1);
      } else {
        state.state.push(stateCode);
      }
    } else {
      state.state = [];
      state.state.push(stateCode);
    }

    history.pushState(null, "", "?".concat(queryString.stringify(state)));
    refreshCharts(state.adjustment, state.state);

    if ($("#finance-table-container").length > 0) {
      $("#finance-table-container").attr("data-states", JSON.stringify(state.state));
      $("#finance-table-container").attr("data-geo", !!state.state.length);
      initTables();
    } else {
      updateDownloadButton(state);
    }
  });
}
export default function () {
  initStatePicker();
}